import { render } from "./Similars.vue?vue&type=template&id=40b63826&scoped=true"
import script from "./Similars.vue?vue&type=script&lang=js"
export * from "./Similars.vue?vue&type=script&lang=js"

import "./Similars.vue?vue&type=style&index=0&id=40b63826&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b63826"]])

export default __exports__